import { render, staticRenderFns } from "./containerTags.vue?vue&type=template&id=460c0014&scoped=true&"
import script from "./containerTags.vue?vue&type=script&lang=js&"
export * from "./containerTags.vue?vue&type=script&lang=js&"
import style0 from "./containerTags.vue?vue&type=style&index=0&id=460c0014&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460c0014",
  null
  
)

export default component.exports